import { supabase } from './supabaseClient';
import { DEFAULT_COLUMN_MAPPING, DEFAULT_TAT_SETTINGS } from '../utils/constants';
import { normalizeServiceType } from '../utils/normalization';

export async function getColumnMapping() {
  const { data, error } = await supabase
    .from('column_mappings')
    .select('*')
    .eq('id', true)
    .single();

  if (error && error.code !== 'PGRST116') throw error;

  const mapping = { ...DEFAULT_COLUMN_MAPPING, ...(data?.mapping || {}) };
  if (data?.dashboard_date_key && mapping[data.dashboard_date_key]) {
    mapping.dashboard_date = mapping[data.dashboard_date_key];
  }
  return {
    mapping,
    dashboardDateKey: data?.dashboard_date_key || 'milestone_end_date',
  };
}

export async function saveColumnMapping(mapping, dashboardDateKey, userId) {
  const payload = {
    id: true,
    mapping,
    dashboard_date_key: dashboardDateKey,
    updated_by: userId,
    updated_at: new Date().toISOString(),
  };

  const { data, error } = await supabase
    .from('column_mappings')
    .upsert(payload, { onConflict: 'id' })
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function getTatSettings() {
  const { data, error } = await supabase
    .from('app_settings')
    .select('*')
    .eq('id', true)
    .maybeSingle();

  if (error && error.code !== 'PGRST116') throw error;

  return {
    defaultTatHours: Number(data?.default_tat_hours ?? DEFAULT_TAT_SETTINGS.defaultTatHours),
    uploadRetentionCount: Number(data?.upload_retention_count ?? DEFAULT_TAT_SETTINGS.uploadRetentionCount ?? 2),
    serviceTatHours: {
      ...DEFAULT_TAT_SETTINGS.serviceTatHours,
      ...(data?.service_tat_hours || {}),
    },
  };
}

export async function saveTatSettings(settings, userId) {
  const normalizedTatHours = Object.entries(settings.serviceTatHours || {}).reduce((acc, [key, value]) => {
    const normalizedKey = normalizeServiceType(key);
    if (normalizedKey && value !== '' && value !== null && value !== undefined) {
      acc[normalizedKey] = Number(value);
    }
    return acc;
  }, {});

  const payload = {
    id: true,
    default_tat_hours: Number(settings.defaultTatHours || DEFAULT_TAT_SETTINGS.defaultTatHours),
    service_tat_hours: normalizedTatHours,
    upload_retention_count: Math.max(1, Number(settings.uploadRetentionCount || DEFAULT_TAT_SETTINGS.uploadRetentionCount || 2)),
    updated_by: userId,
    updated_at: new Date().toISOString(),
  };

  const { data, error } = await supabase
    .from('app_settings')
    .upsert(payload, { onConflict: 'id' })
    .select()
    .single();

  if (error) throw error;
  return data;
}
